export default __webpack_public_path__ + "static/media/Poster_L1.1e614e7a.svg";